const checkoutTabs = {
  init() {
    const checkoutTabsHeads = document.querySelectorAll('.js-toggle-tab-head');

    checkoutTabsHeads.forEach(checkoutTabsHeadItem => {
      let parentOfTabHead = checkoutTabsHeadItem.parentNode;
      let closestTabHead = parentOfTabHead.querySelector('.checkout-tab__head');
      let closestTabBody = parentOfTabHead.querySelector('.js-toggle-tab-body');
      let tabStateIcon = checkoutTabsHeadItem.querySelector('.checkout-toggle__icon');
      checkoutTabsHeadItem.addEventListener('click', function () {
        closestTabBody.classList.toggle('is-tab-close');
        let isActive = closestTabBody.classList.contains('is-tab-close');
        if (isActive) {
          closestTabHead.classList.add('checkout-tab__head--close');
          closestTabHead.classList.remove('checkout-tab__head--open');
          tabStateIcon.classList.add('checkout-toggle__icon--close');
          tabStateIcon.classList.remove('checkout-toggle__icon--open');
        } else {
          closestTabHead.classList.add('checkout-tab__head--open');
          closestTabHead.classList.remove('checkout-tab__head--close');
          tabStateIcon.classList.add('checkout-toggle__icon--open');
          tabStateIcon.classList.remove('checkout-toggle__icon--close');
        }
      }, false);
    });

    var getClosest = function (elem, selector) {
      for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( elem.matches( selector ) ) return elem;
      }
      return null;
    };

    const checkoutBtn = document.querySelectorAll('.js-checkout-tab-button');
    checkoutBtn.forEach( checkoutBtnItem => {
      // let parentOfBtn = checkoutBtnItem.parentNode;
      checkoutBtnItem.addEventListener('click', function(e) {
        e.preventDefault();
        // Get the parent with the `.checkout-tab` class
        let btnTabParent = getClosest(e.target, '.checkout-tab');
        let btnTabSibling = btnTabParent.nextElementSibling;
        let btnTabSiblingHead = btnTabSibling.querySelector('.checkout-tab__head');
        let btnTabSiblingBody = btnTabSibling.querySelector('.js-toggle-tab-body');
        let btnTabSiblingIcon = btnTabSibling.querySelector('.checkout-toggle__icon');
        let isActive = btnTabSiblingBody.classList.contains('is-tab-close');
        if (isActive) {
          btnTabSiblingHead.classList.add('checkout-tab__head--open');
          btnTabSiblingHead.classList.remove('checkout-tab__head--close');
          btnTabSiblingIcon.classList.add('checkout-toggle__icon--close');
          btnTabSiblingIcon.classList.remove('checkout-toggle__icon--open');
          btnTabSiblingBody.classList.remove('is-tab-close');
        }
      });
    });
  },
};

export default checkoutTabs;



// WEBPACK FOOTER //
// ./scripts/modules/checkout-tabs.js